import { useQuery } from '@apollo/client';

import { useEntity } from '@lib/entity';
import { SubjectEntityList } from '@modules/subjects/main/entities';
import { GetSubjectCollectionQuery } from '@modules/subjects/main/graphql';

import type { QueryHookOptions } from '@apollo/client';
import type {
    GetSubjectCollectionQueryType,
    GetSubjectCollectionQueryVariables,
} from '@modules/types/graphql';

const useSubjects = (
    options: QueryHookOptions<
        GetSubjectCollectionQueryType,
        GetSubjectCollectionQueryVariables
    > = {},
) => {
    const queryResult = useQuery<GetSubjectCollectionQueryType, GetSubjectCollectionQueryVariables>(
        GetSubjectCollectionQuery,
        {
            fetchPolicy: 'network-only',
            ...options,
        },
    );

    const { entities: subjects, count } = useEntity(
        () =>
            new SubjectEntityList(
                queryResult.data?.getOLSubjectCollection?.items ?? null,
                queryResult.data?.getOLSubjectCollection?.page?.total,
            ),
        [queryResult.data],
    );

    const result = {
        subjects,
        count,
        ...queryResult,
    };

    return result;
};

export { useSubjects };
